import { useNavigate } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import { Compass } from "lucide-react";

// PATCH 35 M13 — on-brand 404 with real navigation back into the product.
export default function NotFound() {
  const nav = useNavigate();
  let recent = [];
  try { recent = JSON.parse(localStorage.getItem("kadana_recent_projects") || "[]").slice(0, 3); } catch { /* ignore */ }
  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)" }} data-testid="not-found-page">
      <PublicNav />
      <div style={{ margin: "0 auto", padding: "80px 24px", textAlign: "center" }}>
        <Compass size={34} color="var(--muted)" strokeWidth={1.5} aria-hidden="true" />
        <h1 className="k-heading" style={{ fontSize: 34, margin: "16px 0 6px" }}>This page took a wrong turn</h1>
        <p className="k-muted" style={{ fontSize: 15 }}>The page you were after doesn't exist or has moved. Here's the way back.</p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 22, flexWrap: "wrap" }}>
          <button className="k-btn k-btn-primary" data-testid="nf-workspace" onClick={() => nav("/workspace")}>Go to your workspace</button>
          <button className="k-btn k-btn-ghost" data-testid="nf-features" onClick={() => nav("/features")}>Explore features</button>
          <button className="k-btn k-btn-ghost" data-testid="nf-contact" onClick={() => nav("/contact")}>Contact support</button>
        </div>
        {recent.length > 0 && (
          <div style={{ marginTop: 26 }}>
            <div className="k-muted" style={{ fontSize: 12, marginBottom: 6 }}>Recent projects</div>
            {recent.map((p) => <button key={p.id} className="k-link" data-testid={`nf-recent-${p.id}`} style={{ display: "block", margin: "0 auto", fontSize: 13 }} onClick={() => nav(`/project/${p.id}`)}>{p.name}</button>)}
          </div>
        )}
      </div>
      <PublicFooter />
    </div>
  );
}
